import React, { FC } from 'react';
import { create } from 'zustand';

interface Store {
  open: boolean;
  toggle(open?: boolean): void;
}

export const useDocumentsStore = create<Store>((set, get) => ({
  open: false,
  toggle: open => set({ open: open === undefined ? !get().open : open })
}));

export const DocumentsProvider: FC<{ children: React.ReactNode }> = ({
  children
}) => <>{children}</>;
